module.exports = __webpack_public_path__ + "static/img/r-5-2-icon.3fbf5e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-5/r-5-2-icon.png
// module id = wFt5
// module chunks = 0